<div class="reports-configuration-component">
  <div class="row mt-4">
    <div class="col-12 col-md-4">
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">
            <h2 class="my-0" style="color: #224261">{{ 'report_type_configuration' | translation }}</h2>
          </div>
        </div>
        <div class="card-body">
          <app-terminal-selector
            [formGroup]="configurationForm"
            [terminals]="terminals"
            (terminalSelected)="onTerminalSelected($event)"
            (terminalCurrency)="onTerminalCurrency($event)">
          </app-terminal-selector>

          <app-configuration-type-selector
            [formGroup]="configurationForm"
            (configurationTypeChanged)="onConfigurationTypeChanged()">
          </app-configuration-type-selector>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-8">
      <ng-container [ngSwitch]="configurationForm.get('configuration').value">
        <app-irrigation-costs-table
          *ngSwitchCase="'irrigationCosts'"
          [terminal]="terminal"
          [terminalCurrency]="terminalCurrency"
          #irrigationCostsTable>
        </app-irrigation-costs-table>

        <app-fertilization-costs-table
          *ngSwitchCase="'fertilizationCosts'"
          [terminal]="terminal"
          [terminalCurrency]="terminalCurrency"
          #fertilizationCostsTable>
        </app-fertilization-costs-table>

        <app-water-sources-table
          *ngSwitchCase="'waterSources'"
          [terminal]="terminal"
          #waterSourcesTable>
        </app-water-sources-table>

        <app-terminal-configuration-form
          *ngSwitchCase="'terminal'"
          [terminal]="terminal"
          (terminalCurrency)="onTerminalCurrency($event)">
        </app-terminal-configuration-form>
      </ng-container>
    </div>
  </div>
</div>
